export default __webpack_public_path__ + "static/media/firefox.d1ce8a7b.svg";